import { BarChart, Bar, CartesianGrid, XAxis, YAxis, Tooltip } from "recharts"
import { GraficoComponenteProps } from "../../interfaces/dashboardCard"
import { notacaoNumero } from "../../helpers"
import { chavesValoresSiglas } from "../../interfaces/indicadorMensuracao"
import GraficoComponent from "../GraficoComponent"
import NenhumDadoGrafico from "../NenhumDadoGrafico"
import formatarValorTooltip from "../../helpers/formatarDadosGrafico"

export default function GraficoColuna({ indicador }: GraficoComponenteProps) {
    const { sigla, indicadoresMensuracaos } = indicador;

    const chaveValor = sigla.toLowerCase() as keyof chavesValoresSiglas;
    const valores = indicadoresMensuracaos
        .map(dado => Number(dado[chaveValor]))
        .filter(valor => !isNaN(valor));

    let valorMaximo = Math.max(...valores);
    valorMaximo = Math.round(valorMaximo + Math.abs(valorMaximo) * 0.1);

    let valorMinimo = Math.min(...valores);
    valorMinimo = Math.round(valorMinimo - Math.abs(valorMinimo) * 0.1);

    const dadosColoridos = indicadoresMensuracaos.map(dado => {
        const valor = Number(dado[chaveValor]);
        return {
            ...dado,
            fill: valor >= 0 ? "#25AE88" : "#FF4D4F"
        };
    });

    return (
        <GraficoComponent title={indicador.titulo}>
            {indicadoresMensuracaos.length > 0 ? (
                <BarChart data={dadosColoridos}>
                    <CartesianGrid strokeDasharray="3 3" vertical={false} />
                    <XAxis dataKey="periodo" />
                    <YAxis domain={[valorMinimo, valorMaximo]} tickFormatter={notacaoNumero} allowDecimals={false} />
                    <Tooltip formatter={(value) => formatarValorTooltip(sigla, value)} />
                    <Bar dataKey={chaveValor} />
                </BarChart>
            ) : (
                <NenhumDadoGrafico texto="Nenhum dado encontrado " subtexto="para este gráfico" />
            )}
        </GraficoComponent>
    );
}
